<template>
    <router-view />
</template>

<script setup>
</script>

<style scoped>
    @import url('https://fonts.googleapis.com/css?family=Playfair+Display');
</style>